// PODIUM (§13.4): the lounge theme's changes made triumphant. F major at the Podium's 112.5 BPM,
// straight time: tuba on the beats, brass-section stabs, a heroic brass melody, a glock arp and a
// marching backbeat with tambourine. Same A/B harmonic shape as the lounge (I–II7–ii–V, IV–iv–♭VII,
// iii–VI7–ii–V), in plain triads and dominants.
import type { SongDef } from '../songTypes';

export const PODIUM: SongDef = {
  id: 'podium',
  rootMidi: 65,
  scale: 'major',
  swing: 0,
  bars: 16,
  chords: [
    'I', 'I', 'V7/V', 'V7/V', 'ii7', 'V7', 'I', 'V7/IV',
    'IV', 'IV', 'iv', 'bVII', 'iii7', 'V7/ii', 'ii7', 'V7',
  ],
  drums: { kick: 'x.......x.x.....', snare: '....X.......X...', hat: 'x.x.x.x.x.x.x.x.', perc: 'xoxoxoxoxoxoxoxo' },
  drumsB: { kick: 'x.......x.x.....', snare: '....X.......X.oo', hat: 'x.x.x.x.x.x.x.x.', perc: 'xoxoxoxoxoxoxoxo' },
  fill: { kick: 'x.......x.......', snare: '....x...xxxxXXXX', hat: 'x.x.x.x.........', perc: '................' },
  pickup: { kick: 'x.......x.......', snare: 'x..x..x.xxxxXXXX', hat: '................' },
  bass: [
    'F2 - - - C2 - - - F2 - - - A2 - - -',
    'F2 - - - C2 - - - F2 - - - E2 - - -',
    'G2 - - - D2 - - - G2 - - - B1 - - -',
    'G2 - - - D2 - - - G2 - - - A2 - - -',
    'G2 - - - D2 - - - Bb1 - - - D2 - - -',
    'C2 - - - G1 - - - C2 - - - E2 - - -',
    'F2 - - - C2 - - - F2 - - - A2 - - -',
    'F2 - - - C2 - - - Eb2 - - - A1 - - -',
    'Bb1 - - - F2 - - - Bb1 - - - D2 - - -',
    'Bb1 - - - F2 - - - Bb1 - - - A1 - - -',
    'Bb1 - - - F2 - - - Bb1 - - - Db2 - - -',
    'Eb2 - - - Bb1 - - - Eb2 - - - Bb1 - - -',
    'A1 - - - E2 - - - A1 - - - C2 - - -',
    'D2 - - - A1 - - - D2 - - - F#2 - - -',
    'G1 - - - D2 - - - G1 - - - Bb1 - - -',
    'C2 - - - G1 - - - C2 - - - E2 - - -',
  ],
  lead: [
    'C5 - - - F5 - - - A5 - - - - - G5 -',
    'F5 - - - C5 - - - A4 - - - C5 - - -',
    'D5 - - - G5 - - - B5 - - - - - A5 -',
    'G5 - - - F5 - - - D5 - - - B4 - - -',
    'Bb4 - - - D5 - - - G5 - - - F5 - - -',
    'E5 - - - G5 - - - C6 - - - Bb5 - - -',
    'A5 - - - - - - - F5 - - - C5 - - -',
    'Eb5 - - - F5 - - - A5 - - - C6 - - -',
    'D6 - - - - - - - Bb5 - - - F5 - - -',
    'D5 - - - F5 - - - Bb5 - - - D6 - - -',
    'Db6 - - - - - - - Bb5 - - - F5 - - -',
    'G5 - - - Bb5 - - - Eb6 - - - - - - -',
    'E5 - - - A5 - - - C6 - - - - - - -',
    'F#5 - - - A5 - - - D6 - - - C6 - - -',
    'Bb5 - - - - - - - G5 - - - D5 - - -',
    'E5 - - - G5 - - - C6 - - - Bb5 - - -',
  ],
  arp: '8 . 5 . 10 . 5 . 8 . 5 . 12 . 10 .',
  arpOctave: 1,
  comp: 'X-....x-..x-....',
  compB: 'X-....x-..x-..x-',
  voicing: 'close',
  chordRange: [58, 74],
  instruments: { bass: 'tuba', chords: 'brass', lead: 'brass', arp: 'glock', perc: 'tambourine' },
  kit: { kick: 'kick', snare: 'snare', hat: 'hat', crash: 'crash' },
  stabs: 'X.....x...x.....',
  counter: 'glock',
  mix: { hat: -6, perc: -8, arp: -7, chords: -1, bass: -3 },
};
